import { Application } from 'stimulus'

export default Application.start()
